import React, { useContext } from "react"
import { useTranslation } from "react-i18next"

import { ContentTag, connect, isInPlaceEditingActive } from "scrivito"
import {
  AttributeInformationObj,
  AttributeInformationObjClass
} from "scrivito/Objs/AttributeInformation/AttributeInformationObjClass"
import {
  AttributeInformationWrapperObj,
  AttributeInformationWrapperObjClass
} from "scrivito/Objs/AttributeInformationWrapper/AttributeInformationWrapperObjClass"
import { useEvent } from "shared/lib/useEvent"
import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { RJSFFormFieldProps } from "shared/ui/rjsf-form/types"

import { AttributeInformationContext } from "widgets/product-configurator/model/AttributeInformationContext"

import "../../styles/_product-configurator-attribute-information.scss"

function ProductConfiguratorAttributeInformationComponent({
  schema
}: RJSFFormFieldProps) {
  const { t } = useTranslation()
  const context = useContext(AttributeInformationContext)
  const productObj = context?.productObj

  const attributeInformationWrapper = productObj
    ?.get("attributeInformation")
    .find(attrInfo => attrInfo.get("configurationID") === schema.fieldID) as
    | AttributeInformationWrapperObj
    | null
    | undefined

  const attributeInformation = attributeInformationWrapper?.get(
    "attributeInformation"
  ) as AttributeInformationObj | null | undefined

  const createAttributeInformationObj = useEvent(() => {
    let wrapper = attributeInformationWrapper
    if (!wrapper) {
      wrapper = AttributeInformationWrapperObjClass.create({
        title: schema.title ?? "Attribute Information",
        configurationID: schema.fieldID ?? "",
        description: ""
      })
    }
    const newAttributeInformation = AttributeInformationObjClass.create({
      title: schema.title ?? "Attribute Information",
      description: "",
      image: null
    })

    wrapper.update({
      attributeInformation: newAttributeInformation
    })

    productObj?.update({
      attributeInformation: [
        ...(productObj.get("attributeInformation") ?? []).filter(
          attrInfo => attrInfo.get("configurationID") !== schema.fieldID
        ),
        wrapper
      ]
    })
  })

  if (!productObj || !schema.fieldID) {
    return null
  }
  if (!attributeInformation && !isInPlaceEditingActive()) {
    return null
  }

  return (
    <div className="product-configurator-attribute-information">
      {attributeInformation ? (
        <div className="product-configurator-attribute-information__image">
          <ContentTag content={attributeInformation} attribute="imageWidgets" />
        </div>
      ) : null}
      {!attributeInformation && isInPlaceEditingActive() ? (
        <Button
          variant={ButtonVariant.PRIMARY}
          onClick={createAttributeInformationObj}
        >
          {t("Product.Configuration.AttributeInformation.Create")}
        </Button>
      ) : null}
      {isInPlaceEditingActive() ? <div>ID: {schema.fieldID}</div> : null}
    </div>
  )
}

export const ProductConfiguratorAttributeInformation = React.memo(
  connect(ProductConfiguratorAttributeInformationComponent)
)
